import { IconTrash01 } from "@pentabd/icons";
import { UserInfoCard } from "@pentabd/ui";
import { SelectedMemberType } from "@type/procurements/committee";
import { TFunction } from "i18next";

export const CommitteeTableColumn = (
  t: TFunction<"translation", undefined>,
  deleteCommitteeMember: (id: number) => void,
) => {
  return [
    {
      id: 1,
      key: "nameEn",
      name: t("COMMITTEE.FORM.SELECTED_MEMBERS.TABLE_TEXT"),
      render: (nameEn: string, row: SelectedMemberType) => {
        return (
          <UserInfoCard
            title={row?.nameEn || ""}
            subtitle={row?.designation || ""}
            imageURL={row?.image_url || ""}
          />
        );
      },
    },
    {
      id: 2,
      key: "id",
      name: "",
      render: (id: number) => {
        return (
          <div
            onClick={() => deleteCommitteeMember(id)}
            style={{ cursor: "pointer" }}
          >
            <IconTrash01 size={20} fill="danger" />
          </div>
        );
      },
    },
  ];
};
